module.exports = __webpack_public_path__ + "gb-wls.svg?d67608c4a9127c21bc7236eaa82505b9";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/gb-wls.svg
// module id = 1719
// module chunks = 0